import React, { useEffect, useState } from 'react';
import api from '../services/api';
import TableFilter from '../components/TableFilter';
import ActionButtons from '../components/ActionButtons';

interface Guest {
  guest_name: string;
  guest_phone: string;
  event_type: string;
  event_name: string;
  event_date: string;
}

const GuestListPage: React.FC = () => {
  const [guests, setGuests] = useState<Guest[]>([]);
  const [filteredGuests, setFilteredGuests] = useState<Guest[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchGuests = async () => {
      try {
        const response = await api.get('/guests/');
        setGuests(response.data);
        setFilteredGuests(response.data);
      } catch (error) {
        console.error("Error fetching guests", error);
      } finally {
        setLoading(false);
      }
    };
    fetchGuests();
  }, []);

  const handleFilter = (filters: { [key: string]: string }) => {
    let result = guests;

    if (filters.name) {
      result = result.filter(g => g.guest_name.toLowerCase().includes(filters.name.toLowerCase()));
    }
    if (filters.phone) {
      result = result.filter(g => g.guest_phone && g.guest_phone.includes(filters.phone));
    }
    if (filters.type) {
      result = result.filter(g => g.event_type === filters.type);
    }
    if (filters.date) {
      result = result.filter(g => g.event_date.startsWith(filters.date));
    }

    setFilteredGuests(result);
  };

  if (loading) return <div style={{ padding: '20px' }}>Carregando...</div>;

  return (
    <div>
      <div style={{ marginBottom: '30px' }}>
        <h1>Lista de Convidados</h1>
        <p style={{ color: 'var(--text-secondary)' }}>
          Pessoas que marcaram presença como convidados e não estão cadastradas como pais ou colaboradores.
        </p>
      </div>

      <TableFilter
        filters={[
          { key: 'name', label: 'Nome' },
          { key: 'phone', label: 'Telefone' },
          { key: 'date', label: 'Data do Evento', type: 'date' },
          {
            key: 'type', label: 'Tipo de Evento', type: 'select', options: [
              { value: 'Reunião', label: 'Reunião' },
              { value: 'Evento', label: 'Evento' },
              { value: 'Estudo Bíblico', label: 'Estudo Bíblico' }
            ]
          }
        ]}
        onFilter={handleFilter}
      />

      <div className="card" style={{ overflowX: 'auto' }}>
        <table>
          <thead>
            <tr>
              <th>Nome</th>
              <th>Telefone</th>
              <th>Evento</th>
              <th>Tipo</th>
              <th>Data</th>
              <th style={{ textAlign: 'right' }}>Ação</th>
            </tr>
          </thead>
          <tbody>
            {filteredGuests.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: 'center', padding: '30px', color: 'var(--text-light)' }}>
                  Nenhum convidado registrado.
                </td>
              </tr>
            ) : (
              filteredGuests.map((guest, index) => (
                <tr key={index}>
                  <td style={{ fontWeight: '500' }}>{guest.guest_name}</td>
                  <td>{guest.guest_phone || '-'}</td>
                  <td>{guest.event_name}</td>
                  <td><span className="badge badge-info">{guest.event_type}</span></td>
                  <td>{new Date(guest.event_date).toLocaleDateString()}</td>
                  <td style={{ textAlign: 'right' }}>
                    <ActionButtons
                      onWhatsApp={guest.guest_phone ? `https://wa.me/55${guest.guest_phone.replace(/\D/g, '')}` : undefined}
                    />
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GuestListPage;
